import React from "react";
import "./Branchenkompetenz.css";
import BranchenkompetenzIMG from "./BranchenkompetenzIMG";
import { Fade } from "react-awesome-reveal";
import {ThemeProps} from "../../components/styles/themeprops";
import { useTranslation } from "react-i18next";

type SkillsProps = {
  children?: React.ReactNode;
  theme:ThemeProps
};

export default function Skills({
  children,
  theme,
}: SkillsProps) {
  const themeVar = {theme};
   const { t, i18n } = useTranslation();
  return (
    <div className="main" id="skills">

			<div>
        <div className="skills-main-div">
          <Fade direction="left" duration={2000} triggerOnce={true}>
            <div className="skills-image-div">
              {/* <img
                alt="Ashutosh is Analysing Data"
                src={require(`../../assests/images/${skill.imagePath}`)}
              ></img> */}
							<BranchenkompetenzIMG theme={themeVar.theme} />
            </div>
          </Fade>

          <div className="skills-text-div">
						<Fade direction="right" duration={1000} triggerOnce={true}>
              <h1 className="skills-heading" style={{ color: theme.text }}>
                {t("Branchenkompetenz")}
              </h1>
            </Fade>
            <Fade direction="right" duration={2000} triggerOnce={true}>
              <div className="mt-5">
              	<p className="subTitle skills-text" style={{ color: theme.secondaryText }} >
                	{t("Branchenkompetenz.desc")}
								</p>
								<div dangerouslySetInnerHTML={
										 								    {__html: t('Branchenkompetenz.desc.list', {interpolation: {escapeValue: false}})}
										 								} />
																		
              </div>
            </Fade>
          </div>
        </div>
			</div>
			
    </div>
  );
}
